import { render, staticRenderFns } from "./LeitsystemBzlu.vue?vue&type=template&id=44a5386e&scoped=true"
import script from "./LeitsystemBzlu.vue?vue&type=script&lang=js"
export * from "./LeitsystemBzlu.vue?vue&type=script&lang=js"
import style0 from "./LeitsystemBzlu.vue?vue&type=style&index=0&id=44a5386e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44a5386e",
  null
  
)

export default component.exports